import { Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ProductAddToBasketComponentDef } from '@df/catalog-ui/product/add-to-basket/product-add-to-basket.component.def';
import { EdependencyLevel } from '@df/catalog/model';
import { IAddToBasketData } from '@df/session/api/basket/basket';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ICmsModalService } from '@icms/client/assets/modal/icms-modal.service';
import { EGtmAddToCartVia, LocalGtmService } from 'projects/app-default/src/app/module/gtm/gtm.service.decorator';
import { ActionComponent } from 'projects/app-default/src/app/ui/api/action.component';
import { ResultComponent } from 'projects/app-default/src/app/ui/resut/result.component';
import { NBuilderConfig } from '../../builder.config';
import { NBuilderConfigurableSelectionModal } from './configurable-selection-modal/builder-configurable-selection-modal.component';
@Component({
    selector: 'builder-add-to-basket',
    templateUrl: './builder-add-to-basket.html',
    standalone: true,
    imports: [ActionComponent, ResultComponent, TranslationModule]
})
export class BuilderAddToBasketComponent extends ProductAddToBasketComponentDef {
    @Input()
    isDisabled: boolean = false;

    @Input({ required: true })
    storageData!: NBuilderConfig.IStorageData;

    @Input()
    content?: NBuilderConfig.IPageData;

    @Input()
    isPreset: boolean = false;

    private router = inject(Router);
    private gtmService = inject(LocalGtmService);
    private cmsModalService = inject(ICmsModalService);
    private;

    protected override onSuccess(result) {
        result.preventMinibasketOpen = true;
        this.gtmService.gtmAddToCartBeEvent(result, EGtmAddToCartVia.outfit);
        this.router.navigate(['/basket']);
        return super.onSuccess(result);
    }

    private async openSizeSelectionModal(): Promise<void> {
        this.status.busy = true;

        const selections = Object.values(this.storageData.selection!);
        const productsIds = [...selections.map(s => s.productId!), ...selections.map(s => s.matchedProductId!)].filter(Boolean);

        // load verbosity 3 before open modal
        await this.app.resources.product.loadAllIds(productsIds, 3, { dependencyLevel: EdependencyLevel.details, safe: true });

        this.cmsModalService.open(undefined, NBuilderConfigurableSelectionModal.id, undefined, {
            storageData: this.storageData,
            basketRequest: this.basketRequest,
            order: this.content
                ? [
                      ...(this.content['leftSectionRider']?.map(e => e.sectionOption.toString()) || []),
                      ...(this.content['leftSectionHorse']?.map(e => e.sectionOption.toString()) || []),
                      ...(this.content['leftSectionPony']?.map(e => e.sectionOption.toString()) || [])
                  ]
                : undefined
        });
        this.status.busy = false;
    }

    protected override getRequest(): IAddToBasketData[] | undefined {
        const request = super.getRequest();

        request?.forEach(r => {
            r['Is_OB'] = 1;
            if (this.isPreset) {
                r['Is_Preset'] = 1;
            }
        });

        return request;
    }

    override _submit(): void {
        if (
            this.storageData.selection &&
            (Object.values(this.storageData.selection).find(s => !s.matchedProductId) || !this.basketService.isSalable(this.basketRequest))
        ) {
            this.openSizeSelectionModal();
        } else {
            super._submit();
        }
    }

    get displayWarrning(): boolean {
        return (
            this.isDisabled &&
            !!this.storageData.selection &&
            !!Object.values(this.storageData.selection)?.length &&
            !Object.values(this.storageData.selection)?.find(e => !e.matchedProductId)
        );
    }
}
